import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_TH',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'f50da3c3-38dc-4a73-8a27-07c61404ea22',
  ''
);
